/* eslint-disable no-unused-vars */
import ApplicationService from '../services/application.service';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// export const getAppsList = createAsyncThunk('application/getAppsList', async () => {
//   const res = await ApplicationService.getAppsList();
//   return res.data.slice(0, 50);
// });
// export const updateAppsList = createAsyncThunk('application/updateAppsList', async (res) => {
//   return res.slice(0, 50);
// });

const initialApplicationState = {
  showExistAppModal: false,
  showNewAppModal: false,
  showNewCreativeModal: false,
  showActivateDisabledCreativeModel: false,
  showNotificationOnSave: false,
  appsListLoading: false,
  appsListError: false,
  appsList: [],
  currentTab: 'google',
  creativeModalType: 'image',
};

const applicationSlice = createSlice({
  name: 'application',
  initialState: initialApplicationState,
  reducers: {
    // openExistAppModal: (state) => {
    //   state.showExistAppModal = true;
    // },
    // closeExistAppModal: (state) => {
    //   state.showExistAppModal = false;
    // },
    // openNewAppModal: (state) => {
    //   state.showNewAppModal = true;
    // },
    // closeNewAppModal: (state) => {
    //   state.showNewAppModal = false;
    // },
    openNewCreativeModal: (state) => {
      state.showNewCreativeModal = true;
    },
    setCreativeModalType: (state, action) => {
      state.creativeModalType = action.payload;
    },
    closeNewCreativeModal: (state) => {
      state.showNewCreativeModal = false;
    },
    // openActivateDisabledCreativeModel: (state) => {
    //   state.showActivateDisabledCreativeModel = true;
    // },
    closeActivateDisabledCreativeModel: (state) => {
      state.showActivateDisabledCreativeModel = false;
    },
    openShowNotificationOnSave: (state) => {
      state.showNotificationOnSave = true;
    },
    closeShowNotificationOnSave: (state) => {
      state.showNotificationOnSave = false;
    },
    selectTab: (state, action) => {
      state.currentTab = action.payload;
    },
    appsList: (state, action) => {
      state.appsList = action.payload;
    },
  },
  // extraReducers: {
  //   [getAppsList.pending]: () => {
  //     // console.log('Pending');
  //   },
  //   [getAppsList.fulfilled]: (state, { payload }) => {
  //     // console.log('Fetched Successfully!');
  //     return { ...state, appsList: payload };
  //   },
  //   [updateAppsList.fulfilled]: (state, { payload }) => {
  //     // console.log('Fetched Successfully!');
  //     return { ...state, appsList: payload };
  //   },
  //   [getAppsList.rejected]: () => {
  //     // console.log('Rejected!');
  //   },
  // },
});

export const applicationActions = applicationSlice.actions;
export default applicationSlice.reducer;
